




import Component from "vue-class-component";
import Vue from "vue";
import { FormValues } from "@/types";
import FormAddEditBlock from "./FormAddEditBlock.vue";

@Component({
  name: "BlockTagsAdd",
  components: { FormAddEditBlock },
})
export default class BlockTagsAdd extends Vue {
  public save(val: FormValues, BlockBaseFormInstance: any) {
    return this.$emit("save", val.title, BlockBaseFormInstance);
  }
}
